import { useRef, useState } from 'react';
import { ImpressionArea } from '@toss/impression-area';
import { useDidUpdate } from '@toss/react';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { Button, Select } from '@zep/ui';
import { SubscribePlan } from '../../../../../types/SubscriptionType';
import S from './StickyPlanSelect.module.scss';
const plans = [{
  name: 'Free',
  value: 'free'
}, {
  name: 'Basic',
  value: 'basic'
}, {
  name: 'Pro',
  value: 'pro'
}, {
  name: 'Enterprise',
  value: 'enterprise'
}];
export const StickyPlanSelect = (props: StickyPlanSelectProps) => {
  const {
    onChange
  } = props;
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [stuck, setStuck] = useState(false);
  const [primaryPlan, setPrimaryPlan] = useState(plans[0]);
  const [secondaryPlan, setSecondaryPlan] = useState(plans[1]);
  const {
    t
  } = useTranslation(['subscription']);
  const planByButtonType = (type: SubscribePlan) => type === 'free' ? 'sub' : 'primary';
  const buttonTextByType = (type: SubscribePlan) => {
    if (type === 'free') {
      return t('subscription:pricing.comparison.buttonFree');
    }
    if (type === 'enterprise') {
      return t('subscription:pricing.comparison.buttonContact');
    }
    return t('subscription:pricing.comparison.buttonUpgrade');
  };
  const handleChange = (type: 'primary-plan' | 'secondary-plan') => {
    return (selected: (typeof plans)[0]) => {
      const selectedPlan = plans.find(plan => plan === selected);
      if (type === 'primary-plan') {
        setPrimaryPlan(
        // @ts-ignore
        selectedPlan);
      }
      if (type === 'secondary-plan') {
        setSecondaryPlan(
        // @ts-ignore
        selectedPlan);
      }
    };
  };
  useDidUpdate(() => {
    onChange?.([primaryPlan.value, secondaryPlan.value] as SubscribePlan[]);
  }, [primaryPlan, secondaryPlan]);

  // 최 상단 GNB 와 붙을 경우 GNB 의 그림자를 제거하거나 다시 표시한다.
  useDidUpdate(() => {
    // @ts-ignore
    const sentinelRect = sentinelRef.current.getBoundingClientRect();
    if (sentinelRect.y <= 50) {
      document.documentElement.dataset.stuckPlanSelect = 'true';
    } else {
      document.documentElement.dataset.stuckPlanSelect = 'false';
    }
  }, [stuck]);
  return <>
      <ImpressionArea rootMargin="-50px" onImpressionStart={() => setStuck(false)} onImpressionEnd={() => setStuck(true)} data-sentry-element="ImpressionArea" data-sentry-source-file="StickyPlanSelect.tsx">
        <div ref={sentinelRef} className={S.sentinel} />
      </ImpressionArea>
      <div className={S.group}>
        <div className={S.col}>
          <Select options={plans.filter(d => d.value !== secondaryPlan.value)} onChange={handleChange('primary-plan')} defaultValue={plans[0]} isFullWidth data-sentry-element="Select" data-sentry-source-file="StickyPlanSelect.tsx" />
          <div className={cns(S.row, S[primaryPlan.value])}>
            <strong className={S.name}>{primaryPlan.name}</strong>
            {primaryPlan.value !== 'free' && <Button size="xxs" variant={planByButtonType(primaryPlan.value as SubscribePlan)} onClick={() => {
            props.onUpdateStickPlan(primaryPlan.value as SubscribePlan);
          }}>
                {buttonTextByType(primaryPlan.value as SubscribePlan)}
              </Button>}
          </div>
        </div>
        <div className={S.col}>
          <Select options={plans.filter(d => d.value !== primaryPlan.value)} onChange={handleChange('secondary-plan')} defaultValue={plans[1]} isFullWidth data-sentry-element="Select" data-sentry-source-file="StickyPlanSelect.tsx" />
          <div className={cns(S.row, S[secondaryPlan.value])}>
            <strong className={S.name}>{secondaryPlan.name}</strong>
            {secondaryPlan.value !== 'free' && <Button size="xxs" variant={secondaryPlan.value as SubscribePlan === 'free' ? 'sub' : 'primary'} onClick={() => props.onUpdateStickPlan(secondaryPlan.value as SubscribePlan)}>
                {buttonTextByType(secondaryPlan.value as SubscribePlan)}
              </Button>}
          </div>
        </div>
      </div>
    </>;
};
type StickyPlanSelectProps = {
  onChange?: (selected: SubscribePlan[]) => void;
  onUpdateStickPlan: (plan: SubscribePlan) => void;
};